import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import useId from '@indeed/ihl-use-id';
import { parseFieldItems } from '../../utils/fields.js';
import { FORM_SIZES } from '../../constants/index.js';
import { Checkbox } from '../Checkbox/Checkbox.js';
import { FormField } from '../FormField/FormField.js';
import { jsx } from '@emotion/react';
import '@indeed/ifl-css';
import '../../utils/transition.js';
import '../../utils/createResponsive.js';
import '../Label/Label.js';
import '../../utils/styled.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '@indeed/ifl-icons';
import '../Text/Text.js';
import '../Box/Box.js';
import '../Flex/Flex.js';

const CheckboxFormField = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    items,
    name,
    ...props
  } = _ref;
  const {
    disabled,
    invalid,
    size
  } = props;
  const defaultId = `ifl-CheckboxFormField-${useId()}`;
  const id = props.id || defaultId;
  const parsedItems = parseFieldItems(items, id);
  const autoGeneratedHelperTextId = `ifl-CheckboxFormField-helperTextId-${useId()}`;
  const helperTextId = props.helperTextId || (props.helperText ? autoGeneratedHelperTextId : undefined);
  const autoGeneratedErrorTextId = `ifl-CheckboxFormField-errorTextId-${useId()}`;
  const errorTextId = props.errorTextId || (props.errorText ? autoGeneratedErrorTextId : undefined);
  return jsx(FormField, _extends({
    as: "fieldset",
    ref: ref,
    helperTextId: helperTextId,
    errorTextId: errorTextId,
    "aria-describedby": helperTextId
  }, props), parsedItems.map((checkboxProps, index) => jsx(Checkbox, _extends({
    key: `${checkboxProps.id}-${index}`,
    name: name,
    disabled: disabled,
    invalid: invalid,
    "aria-describedby": errorTextId,
    size: size
  }, checkboxProps))));
});
const CHECKBOX_FORM_FIELD_SIZES = FORM_SIZES;
CheckboxFormField.displayName = "CheckboxFormField";

export { CHECKBOX_FORM_FIELD_SIZES, CheckboxFormField };
